var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transaction",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.669,
    height: 17.669,
    viewBox: "0 0 17.669 17.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_365930",
    "data-name": "Path 365930",
    d: "M279.908,243.055l-3.624-1.035a.525.525,0,0,0-.285,0l-3.624,1.035a.519.519,0,0,0-.375.5V246a5.534,5.534,0,0,0,4,5.3.517.517,0,0,0,.283,0,5.534,5.534,0,0,0,4-5.3v-2.443A.519.519,0,0,0,279.908,243.055Zm-1.847,2.935-2.071,2.071a.517.517,0,0,1-.732,0l-1.035-1.035a.518.518,0,1,1,.732-.732l.669.669,1.7-1.7a.518.518,0,1,1,.732.732Z",
    transform: "translate(-262.613 -233.648)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114547",
    "data-name": "Group 114547"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_572",
    "data-name": "Ellipse 572",
    transform: "translate(3.63 3.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365931",
    "data-name": "Path 365931",
    d: "M16.116,0H1.553A1.555,1.555,0,0,0,0,1.553V9.9a1.555,1.555,0,0,0,1.553,1.553h6.8V9.9A1.56,1.56,0,0,1,9.476,8.412L13.1,7.376a1.558,1.558,0,0,1,.85,0c1.493.433,3.294.927,3.718,1.08v-6.9A1.555,1.555,0,0,0,16.116,0ZM3.693,8.352H2.657a.518.518,0,0,1,0-1.035H3.693a.518.518,0,0,1,0,1.035ZM3.658,5.246A1.553,1.553,0,1,1,5.211,3.693,1.555,1.555,0,0,1,3.658,5.246ZM6.8,8.352H5.763a.518.518,0,1,1,0-1.035H6.8a.518.518,0,0,1,0,1.035ZM15.081,4.21H8.869a.518.518,0,0,1,0-1.035h6.212a.518.518,0,1,1,0,1.035Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.febdc71df47e6d20f93e7550a66b45cd.svg";
export { ForwardRef as ReactComponent };